import { computed } from 'vue'
import { useQuery, keepPreviousData } from '@tanstack/vue-query'
import { statsApi } from '@/api'
// PrizePoolRead type used implicitly
import { POLLING_INTERVALS, STALE_TIME, RETRY_CONFIG } from '@/config/query'

export function usePrizePool() {
  const { data, error, isFetching, refetch } = useQuery({
    queryKey: ['stats', 'prizePool'],
    queryFn: async () => {
      const response = await statsApi.getPrizePool()
      if (response.success && response.data) {
        return response.data
      }
      throw new Error(response.error ?? 'Failed to fetch prize pool')
    },
    refetchInterval: POLLING_INTERVALS.BACKEND_API,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    placeholderData: keepPreviousData,
    retry: RETRY_CONFIG.ATTEMPTS,
    staleTime: STALE_TIME.MEDIUM,
  })

  return {
    prizePool: computed(() => data.value),
    totalAmount: computed(() => data.value?.total.amount ?? 0),
    prizes: computed(() => data.value?.prizes ?? []),
    isLoading: computed(() => isFetching.value && !data.value),
    hasError: computed(() => Boolean(error.value)),
    errorMessage: computed(() => error.value?.message ?? 'Failed to load prize pool'),
    refetch,
  }
}
